export const ME_NOW = 'MeNow';
export const ME_NEXT = 'MeNext';
export const BOTH_ME_NOW_AND_ME_NEXT = 'BothMeNowAndMeNext';
export const MAX_REC_COURSES = 6;
export const ARCHETYPE_STEPS = [
  'Select Archetypes',
  'Reflect',
  'One last question'
];
